var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',{staticClass:"compensation-chart-key"},_vm._l((_vm.values),function(datum){return _c('tr',{key:datum.label},[_c('th',[_vm._v(_vm._s(datum.label))]),_c('td',{staticClass:"percentage-bar"},[_c('div',{style:({
                    'margin-left': `${(1 - datum.percentage) * 100}%`,
                    width: `${datum.percentage * 100}%`,
                    'background-color': datum.color,
                })})]),(_vm.showValues)?_c('td',{staticClass:"compensation-value"},[_vm._v(_vm._s(_vm.formats.currency(datum.value)))]):_vm._e(),_c('td',{staticClass:"compensation-percent"},[_vm._v(_vm._s(_vm.formats.percentage(datum.percentage)))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }